import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "right-wrap" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "tab-nav" }
const _hoisted_5 = { class: "leftitem" }
const _hoisted_6 = { class: "user-profile-container" }

import { ref, onMounted, reactive } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";

// import { useRouter } from 'vue-router'
// const router = useRouter()


const formLabelWidth = "120px";
interface UserInfo {
  uuid: string; // 用户唯一标识
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
  audit_status: number;
}

interface RuleForm {
  uuid: string; // 用户唯一标识
  uname: string; // 用户名
  company: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const activeTab = ref<string>("all");
const SSRData = ref({
  title: "个人头像 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

//接口
const userInfo = ref<UserInfo>({
  uuid: "",
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: 0,
  userlevel: 0,
  phone_verified: 0,
  wechat_verified: 0,
  weibo_verified: 0,
  github_verified: 0,
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: 0,
  following: 0,
  created_at: "",
  audit_status: 1
});

//获取用户简介
const fetchUserInfo = async () => {
  try {
    await axiosInstance
      .get("/api/UserInfo/profile_id", {
        params: { uuid: '1000086' },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;
          form.uname = userInfo.value.uname;
          form.company = userInfo.value.ucompany;
          form.job_title = userInfo.value.job_title;
          form.avatar_url = userInfo.value.avatar_url;
          form.blog_address = userInfo.value.blog_address;
          form.description = userInfo.value.description;
          form.uuid = userInfo.value.uuid;
        }
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

const ruleFormRef = ref<FormInstance>();

const form = reactive<RuleForm>({
  uuid: "",
  uname: "",
  company: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: ""
});

onMounted(() => {
  activeTab.value = "all";
  fetchUserInfo(); // 替换为实际的用户 ID
});

const rules = reactive<FormRules<RuleForm>>({
    uname: [{ required: true, message: "请输入用户名", trigger: "blur" }]
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        uname: form.uname,
        job_title: form.job_title,
        ucompany: form.company,
        blog_address: form.blog_address,
        description: form.description,
        uuid: form.uuid
      };
      axiosInstance
        .post("api/UserInfo/UpdateUserProfile", params)
        .then((res) => {
          var result = res.data;
          if (result.success) {
            ElMessage.success(result.msg);
            userInfo.value.audit_status = 2;
            //router.push({ path: "/user/settings/profile"});
            fetchUserInfo()
          }
          else {
            ElMessage.error(result.msg);
          }
        });
    } else {
      console.log("error!");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "creator-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(CreatorHeader)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreatorSidebar),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_tabs, {
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "个人资料",
                          name: "all",
                          style: {"font-size":"18px"}
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 15 }, {
                        default: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createElementVNode("p", null, "基本信息", -1)),
                          _createVNode(_component_el_form, {
                            ref_key: "ruleFormRef",
                            ref: ruleFormRef,
                            model: form,
                            rules: rules
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "用户名",
                                "label-width": formLabelWidth,
                                prop: "uname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: form.uname,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.uname) = $event)),
                                    maxlength: "20",
                                    style: {"width":"400px"},
                                    "show-word-limit": "",
                                    placeholder: "请输入用户名"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "职位",
                                "label-width": formLabelWidth,
                                prop: "job_title"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: form.job_title,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.job_title) = $event)),
                                    maxlength: "50",
                                    "show-word-limit": "",
                                    style: {"width":"400px"},
                                    placeholder: "请输入你的职位"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "公司",
                                "label-width": formLabelWidth,
                                prop: "company"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: form.company,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.company) = $event)),
                                    maxlength: "50",
                                    "show-word-limit": "",
                                    style: {"width":"400px"},
                                    placeholder: "请输入你的公司"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "个人主页",
                                "label-width": formLabelWidth,
                                prop: "blog_address"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: form.blog_address,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.blog_address) = $event)),
                                    maxlength: "50",
                                    "show-word-limit": "",
                                    style: {"width":"400px"},
                                    placeholder: "请输入你的个人主页"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "个人介绍",
                                "label-width": formLabelWidth,
                                prop: "description"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: form.description,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.description) = $event)),
                                    maxlength: "100",
                                    style: {"width":"400px"},
                                    rows: "4",
                                    placeholder: "请简单的介绍一下自己",
                                    "show-word-limit": "",
                                    type: "textarea"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("div", { class: "profile-content" }, [
                            _createElementVNode("div", { class: "avatar-upload" }, [
                              _createElementVNode("div", { class: "upload-tips" })
                            ])
                          ], -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, {
                    gutter: 120,
                    style: {"margin-top":"120px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, null, {
                        default: _withCtx(() => [
                          (userInfo.value.audit_status ==1)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "danger",
                                size: "large",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm(ruleFormRef.value)))
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("保存修改")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (userInfo.value.audit_status ==2)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                size: "large",
                                type: "warning",
                                disabled: ""
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode("审核中")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})